<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { liveCoachMessageNotification } from './notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    created () {
      this.channel.bind('message.created', (message) => {
        this.addPrivateMessage(message)

        if (message.participant.isGhost) {
          liveCoachMessageNotification({
            name: message.participant.name,
            message: message.message,
            onClick: this.showLiveCoachChat
          }).show()
        }
      })
    },
    methods: mapActions([
      'addPrivateMessage',
      'showLiveCoachChat'
    ])
  }
</script>



// WEBPACK FOOTER //
// message-created.vue?1b6bb106